import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const usePreventPage = () => {
  const navigate = useNavigate();

  const preventGoBack = () => {
    if (window.confirm('입력된 정보가 삭제됩니다.')) {
      navigate(-1);
    }
  };
  const preventClose = (e: BeforeUnloadEvent) => {
    e.preventDefault();
    e.returnValue = '새로고침시 입력된 정보가 삭제됩니다.';
  };

  useEffect(() => {
    window.addEventListener('beforeunload', preventClose, { passive: true });
    window.addEventListener('popstate', preventGoBack, { passive: true });
    return () => {
      window.removeEventListener('beforeunload', preventClose);
      window.removeEventListener('popstate', preventGoBack);
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};

export default usePreventPage;
